import React from "react";
import {useIntl} from "react-intl";
import {useSelector} from "react-redux";
import {createSelector} from "@reduxjs/toolkit";

import {selectDoubleFlat} from "@/data/select_double_flat.js";
import {selectFlat} from "@/data/select_flat.js";
import {hydrateJobs} from "@/panes/jobs/hydrate_jobs.js";
import {orderByReceivedAt} from "@/library/utility/order_by_received_at.js";

import {DashboardJobCard} from "./dashboard_job_card.jsx";

const LIMIT = 5;

export function DashboardJobsTile(props) {
  const intl = useIntl();

  const session = useSelector(s => s.accessControlSession);

  const selectControlServers = selectDoubleFlat("controlServer");
  const selectJobs = selectDoubleFlat("job");
  const selectQueues = selectDoubleFlat("jobQueue");
  const selectSimulators = selectDoubleFlat("simulator");
  const selectUsers = selectFlat("user");

  const selectUsersJobs = createSelector(
    selectJobs, (jobs) => jobs.filter(j => j.createdBy.id === session.user.id)
  );
  const selectOrderedJobs = createSelector(
    selectUsersJobs, orderByReceivedAt
  );
  const selectLimitedJobs = createSelector(
    selectOrderedJobs, oj => oj.slice(0, LIMIT)
  );
  const selectHydratedJobs = createSelector(
    selectControlServers,
    selectQueues,
    selectSimulators,
    selectUsers,
    selectLimitedJobs,
    hydrateJobs
  );

  const jobs = useSelector(selectHydratedJobs);

  return (
    <div className="tile dashboard-jobs-tile dashboard-section">
      <h2 className="dashboard-jobs-title dashboard-section title">
        {intl.formatMessage({id: "dashboard.jobs.title"})}
      </h2>
      {(jobs.length <= 0) && (
        <div className="dashboard-jobs-empty-message">
          {intl.formatMessage({id: "dashboard.jobs.empty"})}
        </div>
      )}
      <ol className="dashboard-jobs-list">
        {jobs.map((job) => (
          <li className="dashboard-job-item item" key={job.id}>
            <DashboardJobCard job={job}/>
          </li>
        ))}
      </ol>
    </div>
  );
}
